import { render, staticRenderFns } from "./MdAffiliateList.vue?vue&type=template&id=fae72692&scoped=true&"
import script from "./MdAffiliateList.vue?vue&type=script&lang=js&"
export * from "./MdAffiliateList.vue?vue&type=script&lang=js&"
import style0 from "./MdAffiliateList.vue?vue&type=style&index=0&id=fae72692&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae72692",
  null
  
)

export default component.exports